import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DeactivateRubricModal } from "../../components/DeactivateRubricModal";
import { ActivateRubricModal } from "../../components/ActivateRubricModal";
import { useAdjudicationEdit } from "../../adjudication-details/hooks/useAdjudicationEdit";

interface Props {
  id: string;
  rubricName: string | null;
  isActive: boolean;
  mutate: () => void;
}

export function RubricActionsDropdown(props: Props) {
  const { id, rubricName, isActive, mutate } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);

  const { submitActiveStatus, isSubmittingActiveStatus } = useAdjudicationEdit({
    mutate,
    rubricName: rubricName ?? "--",
    rubricId: id,
  });

  const handleDeactivateRubric = () => {
    submitActiveStatus(false);
    setIsDeactivateModalOpen(false);
  };

  const handleActivateRubric = () => {
    submitActiveStatus(true);
    setIsActivateModalOpen(false);
  };

  return (
    <>
      <DropdownMenu
        triggerButton={
          <GhostIconButton
            testID="adjudication-item-actions-button"
            size="small"
            icon="more_horiz"
            aria-label={t("Expand menu")}
          />
        }
        placement="bottom right"
        onItemAction={(key) => {
          switch (key) {
            case "edit-rubric":
              navigate(`/adjudication/${id}/checks`);
              break;
            case "deactivate-rubric":
              setIsDeactivateModalOpen(true);
              break;
            case "activate-rubric":
              setIsActivateModalOpen(true);
              break;
          }
        }}
      >
        <MenuSection>
          <MenuItem id="edit-rubric" testID="edit-rubric">
            <Text style="input/text-field">{t("Edit rubric")}</Text>
          </MenuItem>
          {isActive ? (
            <MenuItem id="deactivate-rubric" testID="deactivate-rubric">
              <Text color="text-danger" style="input/text-field">
                {t("Deactivate rubric")}
              </Text>
            </MenuItem>
          ) : (
            <MenuItem id="activate-rubric" testID="activate-rubric">
              <Text style="input/text-field">{t("Reactivate rubric")}</Text>
            </MenuItem>
          )}
        </MenuSection>
      </DropdownMenu>
      <DeactivateRubricModal
        isOpen={isDeactivateModalOpen}
        isLoading={isSubmittingActiveStatus}
        rubricName={rubricName ?? null}
        onCancel={() => setIsDeactivateModalOpen(false)}
        onConfirm={handleDeactivateRubric}
      />
      <ActivateRubricModal
        isOpen={isActivateModalOpen}
        isLoading={isSubmittingActiveStatus}
        rubricName={rubricName ?? null}
        onCancel={() => setIsActivateModalOpen(false)}
        onConfirm={handleActivateRubric}
      />
    </>
  );
}
